/**
 * Slider de recommandations du panier.
 * Custom element : se re-initialise tout seul quand le drawer est re-rendu
 * apres un ajout au panier (innerHTML remplace, l'element se re-upgrade).
 */
class CartRecosComponent extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-recos-track]');
    this.prev = this.querySelector('[data-recos-prev]');
    this.next = this.querySelector('[data-recos-next]');
    if (!this.track) return;

    this.onClick = (e) => {
      if (e.target.closest('[data-recos-prev]')) this.defiler(-1);
      if (e.target.closest('[data-recos-next]')) this.defiler(1);
    };
    this.onScroll = () => this.majFleches();

    this.addEventListener('click', this.onClick);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.majFleches();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    if (this.track) this.track.removeEventListener('scroll', this.onScroll);
  }

  pas() {
    const carte = this.track.querySelector('.cart-reco');
    return carte ? carte.offsetWidth + 10 : 200;
  }

  defiler(sens) {
    this.track.scrollBy({ left: sens * this.pas(), behavior: 'smooth' });
  }

  majFleches() {
    if (!this.prev || !this.next) return;
    const gauche = this.track.scrollLeft <= 4;
    const droite = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 4;
    this.prev.disabled = gauche;
    this.next.disabled = droite;
    this.classList.toggle('cart-recos--at-end', droite);
    this.classList.toggle('cart-recos--at-start', gauche);
  }
}

if (!customElements.get('cart-recos-component')) {
  customElements.define('cart-recos-component', CartRecosComponent);
}
